import {
	FETCHING_ADMIN_OVERVIEW,
	ADMIN_OVERVIEW_FETCHED,
	FETCHING_ADMIN_EMAILS_PER_CUSTOMER,
	ADMIN_EMAILS_PER_CUSTOMER_FETCHED,
	FETCHING_ADMIN_MONTHLY_TREND,
	ADMIN_MONTHLY_TREND_FETCHED,
	FETCHING_ADMIN_RECENT_CAMPAIGNS,
	ADMIN_RECENT_CAMPAIGNS_FETCHED,
	FETCHING_ADMIN_PLATFORM_TOTALS,
	ADMIN_PLATFORM_TOTALS_FETCHED,
	FETCHING_ADMIN_CUSTOMER_MASTER,
	ADMIN_CUSTOMER_MASTER_FETCHED,
} from 'src/actions';

const initState = {
	overview: {
		totalCustomers: 0,
		totalCampaigns: 0,
		totalEmailsSent: 0,
		overallVulnerabilityRate: 0,
	},
	platformTotals: {
		totalEmployees: 0,
		totalActiveCampaigns: 0,
		totalTemplates: 0,
		totalGroups: 0,
	},
	customerMaster: [],
	emailsPerCustomer: [],
	monthlyTrend: [],
	recentCampaigns: [],
	loading: {
		overview: false,
		platformTotals: false,
		customerMaster: false,
		emailsPerCustomer: false,
		monthlyTrend: false,
		recentCampaigns: false,
	},
};

export default function adminDashboardReducer(state = initState, action) {
	switch (action.type) {
		// Overview
		case FETCHING_ADMIN_OVERVIEW:
			return { ...state, loading: { ...state.loading, overview: true } };
		case ADMIN_OVERVIEW_FETCHED:
			return {
				...state,
				overview: action.payload?.data || initState.overview,
				loading: { ...state.loading, overview: false },
			};

		// Platform totals
		case FETCHING_ADMIN_PLATFORM_TOTALS:
			return { ...state, loading: { ...state.loading, platformTotals: true } };
		case ADMIN_PLATFORM_TOTALS_FETCHED:
			return {
				...state,
				platformTotals: action.payload?.data || initState.platformTotals,
				loading: { ...state.loading, platformTotals: false },
			};

		// Customer master
		case FETCHING_ADMIN_CUSTOMER_MASTER:
			return { ...state, loading: { ...state.loading, customerMaster: true } };
		case ADMIN_CUSTOMER_MASTER_FETCHED:
			return {
				...state,
				customerMaster: action.payload?.data?.data || [],
				loading: { ...state.loading, customerMaster: false },
			};

		// Emails per customer
		case FETCHING_ADMIN_EMAILS_PER_CUSTOMER:
			return { ...state, loading: { ...state.loading, emailsPerCustomer: true } };
		case ADMIN_EMAILS_PER_CUSTOMER_FETCHED:
			return {
				...state,
				emailsPerCustomer: action.payload?.data?.data || [],
				loading: { ...state.loading, emailsPerCustomer: false },
			};

		// Monthly trend
		case FETCHING_ADMIN_MONTHLY_TREND:
			return { ...state, loading: { ...state.loading, monthlyTrend: true } };
		case ADMIN_MONTHLY_TREND_FETCHED:
			return {
				...state,
				monthlyTrend: action.payload?.data?.data || [],
				loading: { ...state.loading, monthlyTrend: false },
			};

		// Recent campaigns
		case FETCHING_ADMIN_RECENT_CAMPAIGNS:
			return { ...state, loading: { ...state.loading, recentCampaigns: true } };
		case ADMIN_RECENT_CAMPAIGNS_FETCHED:
			return {
				...state,
				recentCampaigns: action.payload?.data || [],
				loading: { ...state.loading, recentCampaigns: false },
			};

		default:
			return state;
	}
}
